import * as React from "react";
import {
  Button,
  Box,
  Dialog,
  DialogActions,
  DialogContentText,
  DialogContent,
  DialogTitle,
  ListItem,
  ListItemText,
  Typography,
  IconButton,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import { getDate } from "../../utils/data";
import Comments from "./comments";
import { IconWithToolTip } from "../common";
import { appLogger } from "../../utils";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
function PaperComponent(props: any) {
  appLogger.info({
    infoObj: {
      method: "PaperComponent",
      component: "feedback",
      fileName: "previewAttachmantModal.tsx",
      props: props,
    },
  });
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

interface IProps {
  attachmentUrl: string;
  datas: any;
  openAttachmentLargePrvModal: boolean;
  closeAttachmentLargePrvModalFn: any;
  attachmentType?: string;
}

export default function previewAttachmentModalLarge(props: IProps) {
  const {
    openAttachmentLargePrvModal,
    closeAttachmentLargePrvModalFn,
    attachmentUrl,
    datas,
    attachmentType,
  } = props;
  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={openAttachmentLargePrvModal}
        onClose={closeAttachmentLargePrvModalFn}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        // maxWidth="xl"
      >
        {attachmentType && attachmentType.length > 0 && (
          <DialogTitle
            className="close-preview enlarge"
            style={{ cursor: "move" }}
            id="draggable-dialog-title"
          >
            <span
              className="largepopupTtile"
              style={{ textTransform: "capitalize" }}
            >
              {"Enlarged" + " " + attachmentType + " " + "view"}
            </span>
            <IconButton
              onClick={closeAttachmentLargePrvModalFn}
              style={{ fontSize: "1rem" }}
            >
              <IconWithToolTip message="Close" iconName="icon-close" />
            </IconButton>
          </DialogTitle>
        )}
        <DialogContent>
          <DialogContentText>
            <Box sx={{ width: "100%" }}>
              <Grid container>
                <Grid item xs={12}>
                  {attachmentType && attachmentType.length > 0  && (
                    <Box sx={{ p: 1 }}>
                      {attachmentType === "video" ? (
                        <div>
                          <video style={{minWidth: "100%"}} controls autoPlay>
                            <source src={attachmentUrl} type="video/mp4" />
                          </video>
                        </div>
                      ) : attachmentType === "audio" ? (
                        <div>
                          <audio src={attachmentUrl} controls preload="auto" />
                        </div>
                      ) : (
                        <div>
                          <img src={attachmentUrl}></img>
                        </div>
                      )}
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Box>
            {/* <img src={attachmentUrl}></img> */}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}
